import axios from "axios";

const KEY = "crowther_session_token";

export const saveSession = (token) => { if (token) localStorage.setItem(KEY, token); };
export const clearSession = () => localStorage.removeItem(KEY);

// Cookie first; Bearer header is the fallback when the browser drops the cookie.
export const authedHttp = (baseURL) => {
  const http = axios.create({ baseURL, withCredentials: true });
  http.interceptors.request.use((cfg) => {
    const t = localStorage.getItem(KEY);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return http;
};
